//@flow
import { call, put, all, takeLatest, select } from "redux-saga/effects";

import {
  GET_COACHING_SESSION_REQUESTING,
  GET_COACHING_SESSION_SUCCESS,
  GET_COACHING_SESSION_ERROR,
  CREATE_COACHING_SESSION_REQUESTING,
  CREATE_COACHING_SESSION_SUCCESS,
  CREATE_COACHING_SESSION_ERROR,
  UPDATE_COACHING_SESSION_REQUESTING,
  UPDATE_COACHING_SESSION_SUCCESS,
  UPDATE_COACHING_SESSION_ERROR,
  GET_ACTIVE_COACHING_SESSION_SUCCESS,
  GET_ACTIVE_COACHING_SESSION_ERROR,
  GET_ACTIVE_COACHING_SESSION_REQUESTING,
  GET_COACHING_RESOURCES_SUCCESS,
  GET_COACHING_RESOURCES_ERROR,
  GET_COACHING_RESOURCES_REQUESTING,
  VISIT_RESOURCE_SUCCESS,
  VISIT_RESOURCE_ERROR,
  VISIT_RESOURCE_REQUESTING,
  SUBMIT_RESOURCE_FEEDBACK_REQUESTING,
  SUBMIT_RESOURCE_FEEDBACK_SUCCESS,
  SUBMIT_RESOURCE_FEEDBACK_ERROR,
} from "./constants";

import { fetchApi } from "../api";
import { getCoachingSessionResources } from "./selectors";
import i18n from "../../i18n";
import { showAlert } from "@microdoing/shared/services/profileSettings/actions";

const endPoints = {
  getCoachingSession: "/v1/coaching-sessions/",
  updateCoachingSession: "/v1/coaching-sessions/",
  createCoachingSession: "/v1/coaching-sessions/",
  getActiveCoachingSession: "/v1/coaching-sessions/active-session/",
  getResourcesList: "/v1/resources/list",
  visitResource: "/v1/resources/visit/new",
  submitResourceFeedback: "/v1/resources/feedback/submit",
};

const visitResourceApi = data => {
  return fetchApi(`${endPoints.visitResource}`, data, "post");
};

const submitResourceFeedbackApi = data => {
  return fetchApi(`${endPoints.submitResourceFeedback}`, data, "post");
};

const getCoachingSessionApi = data => {
  const { coachId, userId } = data;
  return fetchApi(
    `${endPoints.getCoachingSession}?coachId=${coachId}&userId=${userId}`,
    {},
    "get",
  );
};

const getResourceListApi = data => {
  const { coachId, userId, resourceIds } = data;
  return fetchApi(
    `${endPoints.getResourcesList}?resourceIds=${resourceIds}`,
    {},
    "get",
  );
};

const getActiveCoachingSessionApi = data => {
  const { userId } = data;
  return fetchApi(
    `${endPoints.getActiveCoachingSession}?userId=${userId}`,
    {},
    "get",
  );
};

export const updateCoachingSessionApi = data => {
  const { userId, coachId } = data;
  return fetchApi(endPoints.updateCoachingSession, data, "patch");
};

export const createCoachingSessionApi = data => {
  const { userId, coachId } = data;
  return fetchApi(endPoints.createCoachingSession, data, "post");
};

export function* visitResourceFlow(action) {
  try {
    const response = yield call(visitResourceApi, action.payload);

    yield put({ type: VISIT_RESOURCE_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: VISIT_RESOURCE_ERROR, payload: error });
  }
}

function* submitResourceFeedbackFlow(action) {
  try {
    const response = yield call(submitResourceFeedbackApi, action.payload);

    yield put({ type: SUBMIT_RESOURCE_FEEDBACK_SUCCESS, payload: response });
    yield put(
      showAlert({
        title: i18n.t("feedback-submit-success-title"),
        message: i18n.t("feedback-submit-success-message"),
      }),
    );
  } catch (error) {
    yield put({ type: SUBMIT_RESOURCE_FEEDBACK_ERROR, payload: error });
  }
}

function* getActiveCoachingSessionFlow(action) {
  try {
    const response = yield call(getActiveCoachingSessionApi, action.payload);

    yield put({ type: GET_ACTIVE_COACHING_SESSION_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: GET_ACTIVE_COACHING_SESSION_ERROR, payload: error });
  }
}

function* getCoachingSessionFlow(action) {
  try {
    const response = yield call(getCoachingSessionApi, action.payload);

    yield put({ type: GET_COACHING_SESSION_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: GET_COACHING_SESSION_ERROR, payload: error });
  }
}

function* updateCoachingSessionFlow(action) {
  try {
    const response = yield call(updateCoachingSessionApi, action.payload);

    yield put({ type: UPDATE_COACHING_SESSION_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: UPDATE_COACHING_SESSION_ERROR, payload: error });
  }
}

function* createCoachingSessionFlow(action) {
  try {
    const response = yield call(createCoachingSessionApi, action.payload);

    yield put({ type: CREATE_COACHING_SESSION_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: CREATE_COACHING_SESSION_ERROR, payload: error });
  }
}

function* getCoachingResourcesFlow() {
  try {
    const coachingSessionResources = yield select(getCoachingSessionResources);
    const resourceIds = coachingSessionResources.map(el => el.resourceId);
    const response = yield call(getResourceListApi, {
      resourceIds,
    });

    yield put({ type: GET_COACHING_RESOURCES_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: GET_COACHING_RESOURCES_ERROR, payload: error });
  }
}

function* userWatcher() {
  yield all([
    takeLatest(UPDATE_COACHING_SESSION_REQUESTING, updateCoachingSessionFlow),
    takeLatest(CREATE_COACHING_SESSION_REQUESTING, createCoachingSessionFlow),
    takeLatest(GET_COACHING_SESSION_REQUESTING, getCoachingSessionFlow),
    takeLatest(
      GET_ACTIVE_COACHING_SESSION_REQUESTING,
      getActiveCoachingSessionFlow,
    ),
    takeLatest(GET_COACHING_RESOURCES_REQUESTING, getCoachingResourcesFlow),
    takeLatest(VISIT_RESOURCE_REQUESTING, visitResourceFlow),
    takeLatest(SUBMIT_RESOURCE_FEEDBACK_REQUESTING, submitResourceFeedbackFlow),
  ]);
}

export default userWatcher;
